import React from 'react'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from '../../../util/reactExt'
import { Row, Col, Pagination } from 'antd'
import Image from 'components/ImgWrapper'
import CardLayout from 'components/layout/CardLayout'
import Card from 'components/Card'
import { timeFormat } from 'util/utils'
import { RouteComponentProps } from '../../../../node_modules/@types/react-router'
import * as styles from './index.scss'

type TInfo = {
  title: string
  article_desc: string
  publish_date: string
  update_time: number
  recommand_count: number
  img_url: string
  content: string
  author: string
}
interface Props extends RouteComponentProps<any> {}
interface State {
  id: number
  topicList: any[]
  topicInfo: TInfo
  topicTotal: number
  more: boolean
  pageindex: number
}

@inject('globalStore')
@observer
class TopicDetail extends ComponentExt<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      id: undefined,
      topicList: [],
      topicTotal: 0,
      topicInfo: {} as TInfo,
      more: false,
      pageindex: 1,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      match: {
        params: { id },
      },
    } = nextProps
    return {
      ...prevState,
      id,
    }
  }

  componentDidMount() {
    const { id } = this.state
    this.fetchTopicList(id)
  }

  async fetchTopicList(id, pageindex = 1) {
    try {
      const { data, total, topic_info } = await this.api.topic.getDetail(id, {
        pageindex,
      })
      this.setState({
        topicList: data,
        topicInfo: topic_info,
        topicTotal: total,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  showMore = () => this.setState({ more: true })

  pageChange = page => {
    const { id } = this.state
    this.setState({
      pageindex: page,
    })
    window.scrollTo(0, 444)
    this.fetchTopicList(id, page)
  }

  toDetail(id, type) {
    const topicId = this.state.id || 0
    window.open(`#/course/${id}?type=${type}&topicid=${topicId}`)
  }

  render() {
    const { topicList, topicInfo } = this.state

    const showDesc = (str: string) =>
      str && str.length > 118 ? `${str.slice(0, 118)}...` : str

    return (
      <div>
        <div className={styles.topicHeader}>
          <div className={styles.topicHeaderInner}>
            <Row gutter={32}>
              <Col span={11}>
                <Image src={topicInfo.img_url} width="525" height="300" />
              </Col>
              <Col span={12}>
                <div className={styles.topicInfo}>
                  <div className={styles.topicInfoTitle}>
                    {topicInfo.title || '正在加载'}
                  </div>
                  <div
                    className={styles.topicInfoDesc}
                    style={{ display: 'flex' }}
                  >
                    <p style={{ minWidth: 80 }}>课程简介：</p>
                    <div>
                      <p>
                        {this.state.more
                          ? topicInfo.article_desc
                          : showDesc(topicInfo.article_desc) || ''}
                        {!this.state.more &&
                        topicInfo.article_desc &&
                        topicInfo.article_desc.length > 118 ? (
                          <a onClick={this.showMore}>查看更多</a>
                        ) : null}
                      </p>
                    </div>
                  </div>
                  <div className={styles.topicInfoDesc}>
                    课程时间：{topicInfo.publish_date
                      ? timeFormat(topicInfo.publish_date)
                      : ''}
                  </div>
                  <div className={styles.topicInfoDesc}>
                    课程主题：{topicInfo.content || ''}
                  </div>
                  <div className={styles.topicInfoDesc}>
                    课程讲师：{topicInfo.author || ''}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className={styles.topicBody}>
          <CardLayout title="相关课程" type="video">
            {topicList &&
              topicList
                .filter(item => item)
                .map(
                  (
                    { id, img_url, title, view_count, course_time, type },
                    idx,
                  ) => (
                    <Card
                      key={id || idx}
                      dataType={type}
                      cover={img_url}
                      title={title}
                      watch={view_count}
                      time={course_time}
                      onClick={() => this.toDetail(id, type)}
                    />
                  ),
                )}
          </CardLayout>
          <div
            style={{
              textAlign: 'center',
              backgroundColor: '#fff',
              paddingBottom: 8,
            }}
          >
            <Pagination
              hideOnSinglePage={true}
              total={this.state.topicTotal}
              current={this.state.pageindex}
              pageSize={10}
              onChange={this.pageChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default TopicDetail
